import React from "react"
import { Link } from "gatsby"
import PrintDistribution from "./printDistribution"

export default function Printdirectory({ hash, refer_path, title, url, download }) {
  var QRCode = require("qrcode.react")

  return (
    <main>
      {/* <section className="directory-banner">
        <h1 className="text-center font-weight-bold mb-0 printDirectory-banner-contant">
          Christian <br></br> Business Directory
        </h1>
      </section> */}
      <section style={{marginTop: `8%`}} className="new-directory pt-5 px-3">
        <Link to="/directory">&#60; Back</Link>
        <h3 className="my-4 text-center magazine-title">{title}</h3>
        <p className="text-center font-weight-bold">
          (Select "Full Screen" option in center of directory for best viewing)
        </p>
        <div className="container">
          <div className="row justify-content-center pt-5">
            <div
              className="col-12 mb-2 justify-content-center text-center"
              style={{ border: `1px solid #eee` }}>
              <div
                style={{
                  height:`480px`,
                  position: `relative`,
                  textAlign: `center`,
                  width: `100%`,
                }}>
                <iframe
                  title="digitaldirectory"
                  width="696px"
                  height="480"
                  seamless="seamless"
                  scrolling="no"
                  frameBorder="0"
                  allowFullScreen="true"
                  src={url}
                  className="lazyloaded"
                  data-src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="></iframe>
              </div>
            </div>
            <div className="row my-5">
              <div className="col-lg-6 col-sm-12 dwnld">
                <h3 className="mb-2 mt-2 mt-xl-0 magazine-column-head">
                  Click on the button below to download to your system
                </h3>

                <div className="magazine-column-links mb-3">
                  <a target="_blank" rel="noreferrer noopener" href={download}>
                    Download
                  </a>
                </div>
              </div>

              <div className="col-lg-6 col-sm-12">
                <div className="magazine-column-scan">
                  <div>
                    <p className="pl-4 scan-qr font-weight-light">
                      Scan Code to Download on your Smartphone
                    </p>
                  </div>
                  <div className="text-center">
                    <QRCode
                      value={download}
                      className="QRCODE p-3 "
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <PrintDistribution />
    </main>
  )
}